import { useEffect } from 'react';
import { Box, Heading } from '@chakra-ui/react';
import Layout from '@/features/common/Layout';

const CookieCheck = () => {
  useEffect(() => {
    document.cookie = 'thirdparty_test=1; SameSite=None; Secure; Path=/;';
    const cookieFound = document.cookie.includes('thirdparty_test=1');
    const sendResult = (status) => window.parent?.postMessage(status, '*');
    if (cookieFound && document.hasStorageAccess instanceof Function) {
      console.log('Pact: Cookie found, checking storage access...', document.cookie);
      document
        .hasStorageAccess()
        .then((hasAccess) => {
          console.log('Pact: hasStorageAccess result:', hasAccess);
          sendResult(hasAccess ? 'TP_COOKIE_SUPPORTED' : 'TP_COOKIE_BLOCKED');
        })
        .catch(() => {
          console.log('Pact: catch cookie error:', cookieFound);
          sendResult(cookieFound ? 'TP_COOKIE_SUPPORTED' : 'TP_COOKIE_BLOCKED');
        });
    }
  }, []);
  return (
    <Box data-testid="pact-contracts">
      <Layout pageTitle={'Pact'}>
        <Box mt="6" p={0}>
          <Heading as={'h4'} size={'md'} fontWeight={'bold'} color="brand.900" pb={4}>
            Cookie Check
          </Heading>
          <Box pl={4}>This page checks if 3rd party cookies are enabled in your browser. (when loaded from an iframe)</Box>
        </Box>
      </Layout>
    </Box>
  );
};

export default CookieCheck;
